/**
 * OpenAI Codex: `AGENTS.md` (user-authored instructions) plus the managed
 * memory tree `~/.codex/memories/` — summary, long-form store, raw notes, and
 * per-session rollout summaries (capped to the newest 50 by filename).
 */
import { chunkMarkdown } from '../chunk.js';
import type { MemoryImportItem, NamedText } from '../types.js';
import { epistemicForHeading } from './generic.js';
import { basename } from './util.js';

const MEMORY_FILES = new Set(['memory_summary.md', 'memory.md', 'raw_memories.md']);
const ROLLOUT_CAP = 50;

export function parseCodex(files: NamedText[]): MemoryImportItem[] {
  const items: MemoryImportItem[] = [];
  const rollouts: NamedText[] = [];

  for (const file of files) {
    if (!/\.md$/i.test(file.name)) continue;
    const base = basename(file.name).toLowerCase();
    if (/(^|\/)rollout_summaries\//i.test(file.name)) {
      rollouts.push(file);
    } else if (base === 'agents.md' || base === 'agents.override.md') {
      items.push(...chunkMarkdown(file.text, basename(file.name), { epistemic: 'preference', epistemicForHeading }));
    } else if (MEMORY_FILES.has(base)) {
      items.push(...chunkMarkdown(file.text, basename(file.name), { epistemicForHeading }));
    }
  }

  rollouts.sort((a, b) => b.name.localeCompare(a.name));
  for (const file of rollouts.slice(0, ROLLOUT_CAP)) {
    items.push(...chunkMarkdown(file.text, basename(file.name), { epistemicForHeading }));
  }
  return items;
}
